<script lang="ts">
	import { onMount } from 'svelte'
	import type { SvelteAsr } from 'types/common'

	interface Props {
		asr: SvelteAsr
		chartData: Array<Array<string | number | Date | null>>
	}

	let {
		//
		chartData,
	}: Props = $props()

	const data = google.visualization.arrayToDataTable(chartData)

	const options = {
		// todo ig
		title: 'Dynamic Line graph: Cost, Cost of Goods Sold, Sales vs. Date',
		hAxis: {
			title: 'Date',
			format: 'MMM dd, yyyy',
		},
		vAxis: {
			title: 'Cost, Cost of Goods Sold, Sales',
			format: 'currency',
		},
		tooltip: { isHtml: true },
	}

	onMount(() => {
		const chartDiv = document.getElementById('break-even-graph')
		if (chartDiv) {
			const chart = new google.visualization.LineChart(chartDiv)
			chart.draw(data, options)
		} else {
			alert('Unable to render break even graph')
		}
	})
</script>

<div
	id="break-even-graph"
	style="width: 100%; height: 100%; min-height: 650px;"
></div>
